import styled from 'styled-components';
import { rem } from '../../utils/functions.js';
import { typography } from '../../typography/typography.js';

var ButtonWrapper = /*#__PURE__*/styled.button.withConfig({
  displayName: "styledComponents__ButtonWrapper",
  componentId: "sc-1loha6c-0"
})(["position:relative;display:inline-flex;align-items:center;box-sizing:border-box;border-style:none;background:none;padding:0;text-decoration:none;vertical-align:middle;cursor:pointer;font-family:", ";font-size:", ";font-weight:", ";font-style:", ";font-stretch:", ";line-height:", ";letter-spacing:", ";color:", ";&:hover,&:active,&:focus{.material-icons{color:", ";}color:", ";}", ""], typography.fontFamily, typography.fontSizeSmall, typography.fontWeight, typography.fontStyle, typography.fontStretch, rem(18), typography.letterSpacing, function (_ref) {
  var theme = _ref.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_1;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colorPalette.primaryColors.main.shade_dark_2;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colorPalette.primaryColors.main.shade_dark_2;
}, function (_ref4) {
  var buttonStyle = _ref4.buttonStyle;
  return buttonStyle;
});
process.env.NODE_ENV !== "production" ? ButtonWrapper.displayName = 'ButtonWrapper' : void 0;
var IconWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "styledComponents__IconWrapper",
  componentId: "sc-1loha6c-1"
})(["color:", ";display:inline-flex;.material-icons{vertical-align:text-bottom;}svg,span{width:18px;height:18px;}", ""], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colorPalette.primaryColors.main.shade_default;
}, function (_ref6) {
  var iconStyle = _ref6.iconStyle;
  return iconStyle;
});
process.env.NODE_ENV !== "production" ? IconWrapper.displayName = 'IconWrapper' : void 0;
var ButtonLabel = /*#__PURE__*/styled.span.withConfig({
  displayName: "styledComponents__ButtonLabel",
  componentId: "sc-1loha6c-2"
})(["display:inline-block;padding-left:4px;padding-top:4px;"]);
process.env.NODE_ENV !== "production" ? ButtonLabel.displayName = 'ButtonLabel' : void 0;

export { ButtonLabel, ButtonWrapper, IconWrapper };
